"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("react-hook-schema/core");
const classnames_1 = __importDefault(require("classnames"));
const fieldWrapper_1 = require("./common/fieldWrapper");
const displayWrapper_1 = require("./common/displayWrapper");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const lengthDisplay_1 = require("./common/lengthDisplay");
const hooks_1 = require("./hooks");
const react_hook_form_1 = require("react-hook-form");
const components_1 = require("utils/components");
const MultilineTextSchemaComponent = (props) => {
    var _a;
    const { value, registerProps, fieldState } = (0, core_1.useField)(props, [
        core_1.requiredValidator,
    ]);
    const { onBlur } = registerProps, otherRegisterProps = __rest(registerProps, ["onBlur"]);
    const { schema } = props;
    const confirm = (0, hooks_1.useConfirm)();
    const ref = (0, react_1.useRef)(null);
    const [isConfirmed, setConfirmed] = (0, react_1.useState)(() => !schema.confirmToEdit);
    const [focus, setFocus] = (0, react_1.useState)(false);
    const formContext = (0, react_hook_form_1.useFormContext)();
    const handleOnBlur = () => {
        var _a;
        onBlur();
        setFocus(false);
        fieldState.isDirty && ((_a = schema.autoSaveHandler) === null || _a === void 0 ? void 0 : _a.call(schema));
    };
    return (react_1.default.createElement(fieldWrapper_1.FieldWrapper, { fieldState: fieldState, loading: props.schema.showSpinner &&
            (fieldState === null || fieldState === void 0 ? void 0 : fieldState.isDirty) &&
            ((_a = formContext === null || formContext === void 0 ? void 0 : formContext.formState) === null || _a === void 0 ? void 0 : _a.isSubmitting) },
        react_1.default.createElement(Form_1.default.Control, Object.assign({ as: "textarea", className: (0, classnames_1.default)({
                "has-error": fieldState.invalid,
            }, "enableScrollbar"), rows: schema.rows || 6, value: value || "", placeholder: schema.placeholder, disabled: !isConfirmed, ref: ref, onBlur: handleOnBlur, onFocus: () => {
                setFocus(true);
            } }, otherRegisterProps)),
        ((schema === null || schema === void 0 ? void 0 : schema.count) || !isConfirmed) && (react_1.default.createElement("div", { style: {
                display: "flex",
                justifyContent: "flex-end",
            } },
            !isConfirmed && (react_1.default.createElement(components_1.Button, { type: "button", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    var _b, _c;
                    if ((_b = schema.confirmToEdit) === null || _b === void 0 ? void 0 : _b.message) {
                        const result = yield confirm({
                            message: (_c = schema.confirmToEdit) === null || _c === void 0 ? void 0 : _c.message,
                        });
                        if (!result) {
                            return;
                        }
                    }
                    setConfirmed(true);
                }), tooltip: "\u7DE8\u96C6\u3092\u6709\u52B9\u306B\u3059\u308B", startIcon: "pencil-outline", style: { marginTop: 10 } }, "\u7DE8\u96C6")),
            (schema === null || schema === void 0 ? void 0 : schema.count) && (react_1.default.createElement(lengthDisplay_1.LengthDisplay, { value: value ? value.replace(/\r\n|\r|\n/g, "\n").length : 0, active: focus }))))));
};
MultilineTextSchemaComponent.display = (0, displayWrapper_1.DisplayComponent)("MultilineTextDisplayComponent", (value) => {
    return react_1.default.createElement("div", { style: { whiteSpace: "pre-wrap" } }, value);
});
exports.default = MultilineTextSchemaComponent;
